import { useEffect } from 'react';

function useClickOutside(ref, selectors, onOutsideClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      // Check if click is inside the ref element
      if (ref.current && ref.current.contains(event.target)) {
        return;
      }

      // Check if click is inside any of the extra elements
      const selectorsArray = Array.isArray(selectors) ? selectors : [selectors].filter(Boolean);

      for (const selector of selectorsArray) {
        const element = document.querySelector(selector);
        if (element && element.contains(event.target)) {
          return;
        }
      }

      // If we get here, click was outside all elements
      onOutsideClick();
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, selectors, onOutsideClick]);
}

export default useClickOutside;
